import mitt, { Emitter, Handler } from 'mitt'

const emitter: Emitter = mitt()

export default {
    emit: (type: string, event?) => emitter.emit(type, event),
    on: (type: string, handler: Handler) => emitter.on(type, handler),
    off: (type: string, handler: Handler) => emitter.off(type, handler)
}
